/**
 * First day each vendor channel has full sell-out coverage, keyed by series key. A channel with
 * no entry is covered throughout. Declared, not derived: a brand listed late would otherwise read
 * as a channel starting late (issue author, 2026-10-14).
 */
export type ChannelDataStarts = ReadonlyMap<string, string>;

export abstract class ChannelDataStartRepository {
  abstract load(): Promise<ChannelDataStarts>;
}

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/;

/** The reference row's payload as the map; a malformed entry fails the row rather than one key. */
export function parseChannelDataStarts(raw: unknown): ChannelDataStarts {
  if (raw === null || raw === undefined) return new Map();
  if (typeof raw !== 'object' || Array.isArray(raw)) {
    throw new Error('[ChannelDataStart] reference_data is not an object');
  }
  const out = new Map<string, string>();
  for (const [key, day] of Object.entries(raw)) {
    if (typeof day !== 'string' || !DAY_RE.test(day)) {
      throw new Error(`[ChannelDataStart] "${key}" carries no YYYY-MM-DD day: ${String(day)}`);
    }
    out.set(key, day);
  }
  return out;
}
